// ─── Pending entry-screen repo handoff (ocn-S818-P0) ────────────────────────
// The "I Have a Repo" entry card picks a repo and must navigate straight into
// chat WITHOUT waiting for project creation or codebase ingest (mirrors the
// "I Have a Spec" card's pendingEntrySpecFile.ts seam, ocn-S816-P0). This tiny
// in-memory, single-use slot is the handoff: the entry card sets it right
// before navigating; SubscriberChat's mount effect takes it (clearing the
// slot) on its very next render.

export interface PendingEntryRepo {
  /** owner/name, e.g. "lumeniqjs/todo-app". */
  fullName: string;
  name: string;
  description?: string | null;
  language?: string | null;
}

let pendingRepo: PendingEntryRepo | null = null;

export function setPendingEntryRepo(repo: PendingEntryRepo): void {
  pendingRepo = repo;
}

/** Consumes the pending repo, if any. Clears the slot so it is never reused
 * across sessions/remounts. */
export function takePendingEntryRepo(): PendingEntryRepo | null {
  const repo = pendingRepo;
  pendingRepo = null;
  return repo;
}
